'use strict';

define(['app', '$window'], function (app, $window) {

  var responsiveFlyoutMenu = function responsiveFlyoutMenu() {
    var component = {};
    var _config = {
      attribs: {
        modClass: 'data-modifier-class',
        subNavTarget: 'data-subnav-target'
      },
      selectors: {
        menuStickyRow: '[data-js-element=responsiveFlyoutMenu_menuStickyRow]',
        menuButton: '[data-js-element=menuButton]',
        closeMenu: '[data-js-element=responsiveFlyoutMenu_closeMenu]',
        menuHome: '[data-js-element=responsiveFlyoutMenu_homeButton]',
        backToPrev: '[data-js-element=responsiveFlyoutMenu_backToPrev]',
        targetSubLevel: '.responsiveFlyoutMenu_levelSub-show',
        flyoutSlider: '[data-flyout]',
        subNav: '[data-js-element=subnav]',
        subNavLink: '[data-js-element=subnavLink]',
        subnavLinkSelector: '* > [data-js-element=subnavLink]',
        hasSubnav: '[data-js-element=hasSubnav]',
        menuUnderlay: '[data-js-element=menuUnderlay]',
        mobileUnderlay: '[data-js-element=smallMenuUnderlay]'
      },
      classNames: {
        popUpLock: 'js-popup-lock',
        slideTransform: 'responsiveFlyoutMenu_transform',
        homeButtonShow: 'responsiveFlyoutMenu_menuHomeButton-show',
        backButtonShow: 'responsiveFlyoutMenu_menuBackButton-show',
        stickyMenuShadow: 'responsiveFlyoutMenu_menuStickyRow-shadow',
        menuUnderlayClass: 'responsiveFlyoutMenu_menuUnderlay-show'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      component.mobileNavMenuStatus = 'close';
      component.menuStickyRow = component.element.querySelector(component.config.selectors.menuStickyRow);
      component.menuButton = component.element.querySelector(component.config.selectors.menuButton);
      component.closeMenu = component.element.querySelector(component.config.selectors.closeMenu);
      component.menuShow = component.menuButton.getAttribute(component.config.attribs.modClass);
      component.flyoutSlides = component.element.querySelectorAll(component.config.selectors.flyoutSlider);
      component.subNav = component.element.querySelectorAll(component.config.selectors.subNav);
      component.subNavLink = component.element.querySelectorAll(component.config.selectors.subNavLink);
      component.menuHome = component.element.querySelector(component.config.selectors.menuHome);
      component.backToPrev = component.element.querySelector(component.config.selectors.backToPrev);
      component.hasSubnav = component.element.querySelectorAll(component.config.selectors.hasSubnav);
      component.menuUnderlay = document.querySelector(component.config.selectors.menuUnderlay);
      component.smallMenuUnderlay = component.element.querySelector(component.config.selectors.mobileUnderlay);
      component.headerBreakpoint = 900;
      component.bind();

      return component;
    };

    var _bind = function _bind() {
      component.menuButton.addEventListener('click', component.open);
      component.closeMenu.addEventListener('click', component.close);
      component.smallMenuUnderlay.addEventListener('click', component.close);
      component.backToPrev.addEventListener('click', component.back);

      Array.from(component.flyoutSlides).map(function (el, index) {
        el.setAttribute('data-subnav-index', index);
        el.addEventListener('click', component.triggerSlide, false);
        if (index === component.flyoutSlides.length - 1) {
          component.allSubnavLinksFound = true;
        }
      });
      Array.from(component.flyoutSlides).map(function (el) {
        return el.addEventListener('scroll', component.addShadow, false);
      });
      Array.from(component.flyoutSlides).map(function (el) {
        return el.addEventListener('transitionend', component.removeShadow, false);
      });

      $window.addEventListener('resize', component.resizeEvent);

      Array.from(component.hasSubnav).map(function (el) {
        return el.addEventListener('mouseenter', component.showMenuUnderlay, false);
      });
      Array.from(component.hasSubnav).map(function (el) {
        return el.addEventListener('mouseleave', component.hideMenuUnderlay, false);
      });
    };

    var _addShadow = function _addShadow(e) {
      var scrollPosition = e.target.scrollTop;
      if (scrollPosition > 5) {
        component.menuStickyRow.classList.add(component.config.classNames.stickyMenuShadow);
      } else {
        component.menuStickyRow.classList.remove(component.config.classNames.stickyMenuShadow);
      }
    };

    var _removeShadow = function _removeShadow() {
      component.menuStickyRow.classList.remove(component.config.classNames.stickyMenuShadow);
    };

    var _open = function _open() {
      component.prevScrollTop = $window.pageYOffset;
      component.menuButton.classList.add(component.menuShow);
      component.menuButton.parentElement.classList.add('responsiveFlyoutMenu-overlay');
      component.smallMenuUnderlay.classList.add(component.config.classNames.menuUnderlayClass);
      component.mobileNavMenuStatus = 'open';
      document.documentElement.classList.add(component.config.classNames.popUpLock);
      document.body.style.top = -component.prevScrollTop + 'px';

      app.publish('columbo/track', 'responsiveFlyoutMenu', 'open', 'mobile menu');
    };

    var _close = function _close() {
      component.menuButton.classList.remove(component.menuShow);
      component.menuButton.parentElement.classList.remove('responsiveFlyoutMenu-overlay');
      component.smallMenuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
      component.mobileNavMenuStatus = 'close';
      document.documentElement.classList.remove(component.config.classNames.popUpLock);
      document.body.style.top = '';
      app.element.scrollTo(component.prevScrollTop);
      component.resetMenu();

      app.publish('columbo/track', 'responsiveFlyoutMenu', 'close', 'mobile menu');
    };

    var _back = function _back() {
      var lastTransform = component.element.querySelectorAll('.' + component.config.classNames.slideTransform);
      if (lastTransform.length === 1) {
        component.backToPrev.classList.remove(component.config.classNames.backButtonShow);
        component.menuHome.classList.add(component.config.classNames.homeButtonShow);
      }

      lastTransform[lastTransform.length - 1].classList.remove(component.config.classNames.slideTransform);
      Array.from(component.subNav).map(function (el) {
        return el.scrollTop = 0;
      });
    };

    var _resetMenu = function _resetMenu() {
      Array.from(component.flyoutSlides).map(function (el) {
        if (el.classList.contains(component.config.classNames.slideTransform)) {
          el.classList.remove(component.config.classNames.slideTransform);
        }
      });
      Array.from(component.subNav).map(function (el) {
        return el.scrollTop = 0;
      });
      component.backToPrev.classList.remove(component.config.classNames.backButtonShow);
      component.menuHome.classList.add(component.config.classNames.homeButtonShow);
    };

    var _showMenuUnderlay = function _showMenuUnderlay() {
      component.menuUnderlay.classList.add(component.config.classNames.menuUnderlayClass);
    };

    var _hideMenuUnderlay = function _hideMenuUnderlay() {
      component.menuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
    };

    var _findSubnavLink = function _findSubnavLink(el) {
      while (el.getAttribute('data-js-element') !== 'subnav') {
        if (el.getAttribute('data-js-element') === 'subnavLink') {
          break;
        }
        el = el.parentNode;
      }
      return el;
    };

    var _triggerSlide = function _triggerSlide(e) {
      var link = component.findSubnavLink(e.target);
      e.stopPropagation();

      if (link.getAttribute('data-js-element') !== 'subnavLink' || component.mobileNavMenuStatus === 'close') {
        return;
      }
      e.preventDefault();
      var modClass = void 0;

      component.modClass = link.getAttribute('data-expand-class');

      if (component.allSubnavLinksFound) {
        var subNavIndex = e.currentTarget.getAttribute('data-subnav-index');
        var subnavLinks = component.subNav[subNavIndex].querySelectorAll(component.config.selectors.subnavLinkSelector);

        for (var i = 0; i < subnavLinks.length; i++) {
          var subnavlink = subnavLinks[i];
          if (subnavlink !== link) {
            modClass = subnavlink.getAttribute('data-expand-class');
            subnavlink.classList.remove(modClass);
          }
        }

        link.classList.add(component.modClass);

        e.currentTarget.classList.add(component.config.classNames.slideTransform);
        component.backToPrev.classList.add(component.config.classNames.backButtonShow);
        component.menuHome.classList.remove(component.config.classNames.homeButtonShow);
      }
    };

    var _resizeEvent = function _resizeEvent() {
      if (component.getWindowWidth() > component.headerBreakpoint) {
        component.menuButton.classList.remove(component.menuShow);
        component.mobileNavMenuStatus = 'close';
        component.smallMenuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
        component.resetMenu();
      } else {
        component.menuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
      }
    };

    var _getWindowWidth = function _getWindowWidth() {
      return $window.innerWidth;
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.findSubnavLink = _findSubnavLink;
    component.triggerSlide = _triggerSlide;
    component.open = _open;
    component.close = _close;
    component.back = _back;
    component.resetMenu = _resetMenu;
    component.showMenuUnderlay = _showMenuUnderlay;
    component.hideMenuUnderlay = _hideMenuUnderlay;
    component.resizeEvent = _resizeEvent;
    component.addShadow = _addShadow;
    component.removeShadow = _removeShadow;
    component.getWindowWidth = _getWindowWidth;

    return component;
  };

  return responsiveFlyoutMenu;
});
//# sourceMappingURL=responsiveFlyoutMenu.js.map
